import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UrlService } from '@services/url.service';
import { selectContextSite } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { links } from './link-info';
import { MbIconText, MbIcon } from '@am/moebius';

@Component({
  selector: 'am-interlinking',
  standalone: true,
  styleUrls: ['./interlinking.component.scss'],
  templateUrl: './interlinking.component.html',
  imports: [MbIconText, MbIcon],
})
export class InterlinkingComponent implements OnInit, OnDestroy {
  public unSubscribe$ = new Subject<void>();
  public site: string;
  public linksList: any;

  constructor(private store$: Store<IHotelsAppState>, private urlService: UrlService) {}

  public ngOnInit(): void {
    this.store$
      .pipe(takeUntil(this.unSubscribe$), select(selectContextSite))
      .subscribe((site) => (this.site = site));
    this.generateLinks();
  }

  public generateLinks() {
    const iternationalsLinks = this.getDestinationLinks('international');
    const nationalLinks = this.getDestinationLinks('national');
    const randomLinks = this.getRandomLinks();
    this.linksList = [...iternationalsLinks, ...nationalLinks, ...randomLinks];
  }

  public getDestinationLinks(type) {
    if (links[this.site] && links[this.site][type]) {
      return this.getUrl(links[this.site][type]);
    }
    return [];
  }

  public getRandomLinks() {
    if (links[this.site] && links[this.site].random && !!links[this.site].random.length) {
      const random = Math.floor(Math.random() * 4 + 0);
      const group = 'group-' + (random + 1);
      return this.getUrl(links[this.site].random[random][group]);
    }
    return [];
  }

  public getUrl(list) {
    const updatedList = list.map((data) => {
      data.url = this.makeUrl(data.cityName, data.cityId);
      return data;
    });
    return updatedList.slice(0, 4);
  }

  public makeUrl(cityName, cityId) {
    cityName = this.urlService.normalizeUrl(cityName);
    const url = `/hoteles/destinos/hoteles-en-${cityName}-${cityId}`;
    return url;
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
